














// Import vendors ----------------------------------------------------------------------------------
import { defineComponent } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartWalkingContainerGroupBanner from '@/components/charts/walking/containers/ChartWalkingContainerGroupBanner.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ExportationFrameWalkingChartBanner',
  components: {
    ChartWalkingContainerGroupBanner
  },
  props: {
    aggregates: {
      type: Object,
      required: true
    },
    displayMetrics: {
      type: Object,
      required: true
    },
    norms: {
      type: Object,
      required: true
    },
    degraded: {
      type: Boolean
    },
    analysisDate: {
      type: String,
      required: false
    },
    analysis: {
      type: Object,
      required: true
    }
  },
  setup() {
    const opacity = 1;
    const width = 24;

    return {
      opacity,
      width
    };
  }
});
